module.exports = __webpack_public_path__ + "img/seedBag02.4717a23d.jpg";